<template>
  <div
    v-show="shouldShow"
    class="session-timeout-expired-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="session-timeout-expired-title"
  >
    <div class="session-timeout-expired-card" @click.stop>
      <h5 id="session-timeout-expired-title" class="session-timeout-expired-title">
        {{ $t('session_timeout.title') }}
      </h5>

      <div class="session-timeout-expired">
        <div class="expired-icon">
          <feather-icon icon="AlertCircleIcon" size="36" />
        </div>
        <p class="expired-message">
          {{ $t('session_timeout.expired') }}
        </p>
      </div>

      <div class="session-timeout-expired-footer">
        <button
          type="button"
          class="btn btn-primary"
          @click="goToLogin"
        >
          {{ $t('session_timeout.go_to_login') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FeatherIcon from '@/components/FeatherIcon.vue'
import sessionTimeoutService from '@/services/SessionTimeoutService'

export default {
  name: 'SessionTimeoutExpiredPopup',
  components: {
    FeatherIcon
  },
  data() {
    return {
      expired: false,
      goingToLogin: false,
      unsubscribe: null
    }
  },
  computed: {
    shouldShow() {
      return this.expired && this.$route.path !== '/login'
    }
  },
  methods: {
    goToLogin() {
      if (this.goingToLogin) return
      this.goingToLogin = true

      sessionTimeoutService.beginLogoutToLogin()
      this.$router.replace('/login').catch(() => {})
      this.$store.dispatch('auth/logout', { skipLoading: true })
    }
  },
  mounted() {
    document.body.appendChild(this.$el)
    this.unsubscribe = sessionTimeoutService.subscribeExpirePrompt(active => {
      this.expired = active
      if (active) {
        this.goingToLogin = false
      }
    })
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }
}
</script>

<style lang="scss">
.session-timeout-expired-overlay {
  position: fixed;
  inset: 0;
  z-index: 20000012;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(34, 41, 47, 0.55);
}

.session-timeout-expired-card {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 0.428rem;
  box-shadow: 0 8px 32px rgba(34, 41, 47, 0.28);
}

.session-timeout-expired-title {
  margin: 0;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #ebe9f1;
  font-size: 1.1rem;
  font-weight: 600;
  color: #5e5873;
}

.session-timeout-expired {
  padding: 1.25rem 1.25rem 0.5rem;
  text-align: center;

  .expired-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    margin-bottom: 1rem;
    border-radius: 50%;
    color: #b91c1c;
    background-color: rgba(239, 68, 68, 0.16);
  }

  .expired-message {
    margin-bottom: 0;
    color: #5e5873;
    line-height: 1.5;
  }
}

.session-timeout-expired-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1.25rem;
  border-top: 1px solid #dee2e6;

  .btn {
    min-width: 150px;
  }
}

.dark-layout .session-timeout-expired-card {
  background: #283046;
}

.dark-layout .session-timeout-expired-title,
.dark-layout .session-timeout-expired .expired-message {
  color: #d0d2d6;
}

.dark-layout .session-timeout-expired-title,
.dark-layout .session-timeout-expired-footer {
  border-color: #3b4253;
}
</style>
